import React from 'react';
import { Flex } from '@qga/roo-ui/components';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';
import SkeletonCard from 'components/SkeletonCard';

const LoaderSkeletonCard = React.memo(() => {
  return (
    <SkeletonCard p={0} width={['100%', 394]}>
      <Flex flexDirection="column" justifyContent="center">
        <Flex flexDirection="row" justifyContent="space-between">
          <Flex flexDirection="column" justifyContent="flex-start">
            <PulsingLoadingBlock height={32} width={383} borderRadius="rounded" />
          </Flex>
        </Flex>
        <Flex flexDirection="row" alignItems="baseline" flexWrap="wrap">
          <Flex alignItems="center" mb={1}>
            <PulsingLoadingBlock height={20} width={110} borderRadius="rounded" />
            <PulsingLoadingBlock height={20} width={110} borderRadius="rounded" />
          </Flex>
        </Flex>
      </Flex>
    </SkeletonCard>
  );
});

LoaderSkeletonCard.displayName = 'LoaderSkeletonCard';

export default LoaderSkeletonCard;
